import {useNavigate} from '@tanstack/react-router';
import {
  FormOptions,
  useDiagnosticReportFormModalContext
} from '@/patient/context/DiagnosticReportFormModalContext';
import patientPaths from '@/patient/routing/paths';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';

/**
 * Returns a click handler that opens the appropriate upload-photo flow for the
 * current company: the image-protocol wizard for clinical-trial companies, and
 * the legacy diagnostic-report form modal for everyone else.
 *
 * For the CT branch the `options` argument is ignored because the wizard runs
 * on its own page and has no way to receive modal-scoped callbacks.
 */
export default function useOpenUploadPhoto() {
  const company = useCompany();
  const navigate = useNavigate();
  const openDiagnosticReportFormModal = useDiagnosticReportFormModalContext();

  return function openUploadPhoto(options?: FormOptions) {
    if (company.isForClinicalTrials) {
      navigate({to: patientPaths.IMAGE_PROTOCOL_REQUEST});
      return;
    }
    openDiagnosticReportFormModal(options);
  };
}
